import { Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useOnboardingStore } from '../hooks/useOnboardingStore';
import * as S from './AlertMessage.styles';

export interface AlertMessageProps {
  tableRef: React.RefObject<HTMLTableRowElement | null>;
  alertMessage: {
    message: string;
    isError?: boolean;
  };
  insideModal?: boolean;
  isEntitiesOverflowing: boolean;
  clearMessage: () => void;
}

export const AlertMessage = ({
  tableRef,
  alertMessage,
  insideModal,
  isEntitiesOverflowing,
  clearMessage,
}: AlertMessageProps) => {
  const { t } = useTranslation(['watchlistManager']);
  const { resolvedEntityData } = useOnboardingStore(state => ({
    resolvedEntityData: state.resolvedEntityData,
  }));

  const onClickViewUnmapped = () => {
    tableRef.current?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  };

  if (!alertMessage.message) {
    return null;
  }

  const currentUnMappedEntities = resolvedEntityData.entities.filter(
    e => !e.primaryEntity.tag
  );

  return (
    <S.AlertContainer
      $isError={alertMessage.isError}
      $insideModal={insideModal}
    >
      <S.MessageWrapper>
        <Icon
          size={20}
          iconName="InformationCircle"
          fillColor={
            alertMessage.isError
              ? 'var(--icon-critical)'
              : 'var(--icon-primary)'
          }
        />
        <S.AlertDescription>{alertMessage.message}</S.AlertDescription>
        <S.Close onClick={clearMessage}>
          <Icon iconName="Close" size={14} />
        </S.Close>
      </S.MessageWrapper>
      {!!currentUnMappedEntities.length && isEntitiesOverflowing && (
        <S.StyledViewUnMapped
          variant="secondary"
          size="small"
          label={t('watchlistManager:alertMessage.viewUnmapped')}
          onClick={onClickViewUnmapped}
        />
      )}
    </S.AlertContainer>
  );
};
